<template>
  <v-form v-model="valid" ref="form" @submit.prevent="onLogin">
    <v-snackbar
      top
      timeout="3000"
      transition="slide-y-transition"
      v-model="alert"
      color="error"
      >{{ alertMsg }}</v-snackbar
    >
    <v-row>
      <v-col cols="12">
        <v-text-field
          label="Email"
          name="email"
          required
          :rules="[rules.required, rules.email]"
          v-model="email"
          autocomplete="false"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          label="Password"
          name="password"
          required
          :rules="[rules.required, rules.password.min]"
          v-model="password"
          :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
          v-on:click:append="show = !show"
          :type="show ? 'text' : 'password'"
        ></v-text-field>
      </v-col>

      <v-col cols="12" class="text-center">
        <a href="/forgot" style="text-decoration: none" class="sokoDeep--text"
          >Forgot Password?</a
        >
      </v-col>

      <v-col cols="12">
        <v-btn
          block
          large
          rounded
          depressed
          :loading="loading"
          :disabled="!valid"
          class="sokoDeep"
          :dark="valid"
          type="submit"
          >Login</v-btn
        >
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "Login",
  props: {
    rules: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    email: "", // email
    password: "", // password

    loading: false, // form button loading status
    show: false, //password visibility status
    valid: true, // form validity
    alert: false, // alert visisbility
    alertMsg: "Error!", // alert message
    networkError: false, // error while logging in is a network error
  }),
  methods: {
    ...mapActions(["authenticateUser"]),
    async onLogin() {
      if (this.$refs.form.validate()) {
        const credentials = {
          username: this.email,
          password: this.password,
        };
        this.loading = true;
        // console.log(credentials);
        const isLoggedIn = await this.authenticateUser(credentials).catch(
          (err) => {
            console.log(err);
            this.networkError = true;
            return false;
          }
        );
        if (isLoggedIn) {
          // Redirect to homepage
          // this.$router.push("/");
          this.$emit("loginSuccess");
        } else {
          this.alert = true;
          if (this.networkError) {
            this.alertMsg =
              "No connection was established to log you in. Please check your internet connection and try again!";

            // reset network error
            this.networkError = false;
            this.loading = false;
            return;
          }
          this.alertMsg =
            "Your login credentials do not match anything in our database. Please check you email and password and try again!";
        }
      }
      this.loading = false;
    },
  },
};
</script>

<style>
</style>